
export * from './radiology-template.service';
